module.exports = __webpack_public_path__ + "static/media/bg_topo.18309ccc.jpg";